import React, { useEffect, useState } from 'react'

function HackImageLcp() {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => setLoaded(true), 1000)
  }, [])

  return (
    <img
      width={99999}
      height={99999}
      onLoad={() => setLoaded(true)}
      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+"
      style={{
        pointerEvents: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '97vw',
        height: '97vh',
        maxWidth: '97vw',
        maxHeight: '97vh',
        visibility: loaded ? 'hidden' : 'visible',
      }}
    />
  )
}

export default HackImageLcp
